const apiUrl = "https://xhy4-8lmv-7ogu.n7e.xano.io/api:0sm5rxq-/"

export const confirmMessage = async (email) => {
    const endpoint = "/message/confirm_message";
    const requestUrl = apiUrl + endpoint;
    const data = {
        "email": email
    };
    try {
        const response = await fetch(requestUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        console.log("There's been an error", error)
    }
};
